import { finalize, map, Observable, tap } from 'rxjs';
import { DataService, IModel, toModel } from '../../../../core/service/base/data.service';
import { DataServiceBase } from '../../../../core/service/base/data.service.base';
import { MessageService } from '../../../../core/service/message.service';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../../app.config';
import { RentInvoicingOrderCreateSingleModel } from '../../../model/rent-invoicing/rent-invoicing-order-create-single-model';
import { Invoice } from '../../../../invoice/model/invoice';
import { ProgressBarService } from '../../../../core/service/progress-bar.service';
import { RentInvoicingOrderSettings } from '../../../model/rent-invoicing/rent-invoicing-order-settings';

@Injectable()
export class RentInvoicingOrderSingleLeaseService extends DataServiceBase {
  constructor(
    protected client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    progressBar: ProgressBarService,
    private _messageService: MessageService
  ) {
    super(client, _messageService, progressBar, config, 'rent-invoicing-order');
  }

  getLeaseAgreementNewInvoicesForm(id: string): Observable<any> {
    this.progressBar.start();
    return this.client.get(`${this.endpoint}/single-lease-default/${id}`).pipe(finalize(() => this.progressBar.stop()));
  }

  prepareImdForPreview(form: RentInvoicingOrderSettings): Observable<any> {
    this.progressBar.start();
    return this.client
      .post<any[]>(`${this.endpoint}/single-lease-preview-prepare-imd`, JSON.stringify(form))
      .pipe(finalize(() => this.progressBar.stop()));
  }

  previewSingle(form: RentInvoicingOrderSettings): Observable<any> {
    this.progressBar.start();

    return this.client.post<any[]>(`${this.endpoint}/single-lease-preview`, JSON.stringify(form)).pipe(
      map(data => {
        if (Array.isArray(data)) {
          for (let group of data) {
            if (Array.isArray(group.invoices)) {
              group.invoices = group.invoices.map(item => toModel(Invoice, item));
            }
          }
        }
        return data;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  createNewSingleLease(model: RentInvoicingOrderCreateSingleModel, options: { notifyUser: boolean } = { notifyUser: true }): Observable<IModel> {
    const { appendixes, ...cleanModel } = model;

    this.progressBar.start();
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify(cleanModel));

    if (appendixes) {
      for (const file of appendixes) {
        formData.append('appendixes[]', file, file.name);
      }
    }
    return this.client.post<IModel>(`${this.endpoint}/single-lease`, formData).pipe(
      tap(() => {
        if (options?.notifyUser) this._messageService.showSuccess();
      }),
      finalize(() => this.progressBar.stop())
    );
  }
}
